import React from 'react';
import Modal from '../../../../../components/Modal';
import Panel from '../../../../../components/outline/Panel';
import CheckBoxGroupForm from '../../../../../components/form/CheckBoxGroupForm';
import TextAreaForm from '../../../../../components/form/TextAreaForm';
import { BRAND_REJECT_TYPE_CHECKBOX_LIST } from '../../../../../constants/service/app/brandConstants';
import { formRequiredRules } from '../../../../../lib/formRules';
import './RejectStoreModal.scss';

const RejectStoreModal = (props) => {
  const { isOpen, data, closeModal, onSubmit, form, setData } = props;
  const { rejectTypeList } = data;

  return (
    <Modal
      title="브랜드 입점거절하기"
      isOpen={isOpen}
      width={700}
      height={600}
      isFooter={true}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <Panel className="reject-brand-modal">
        <div className="panel-body">
          {/*거절타입*/}
          <CheckBoxGroupForm
            label="거절 타입"
            form={form}
            initialValue={rejectTypeList}
            rules={[formRequiredRules(true, '거절 타입을 선택해주세요.', false)]}
            onChange={(value) => setData({ path: ['rejectBrandModal', 'data', 'rejectTypeList'], value })}
            list={BRAND_REJECT_TYPE_CHECKBOX_LIST}
            name="rejectTypeList"
          />

          {/*거절 상세 사유*/}
          <TextAreaForm
            form={form}
            label="거절 상세 사유"
            rules={[formRequiredRules(true, '상세 사유를 입력해주세요.')]}
            onChange={(value) =>
              setData({
                path: ['rejectBrandModal', 'data', 'rejectReason'],
                value,
              })
            }
            name="rejectReason"
            rows={4}
          />
        </div>
      </Panel>
    </Modal>
  );
};

export default RejectStoreModal;
